import React from 'react';

import './input-group.scss';

interface InputGroupProps {
  className?: string;
  columnCount?: number;
}

function InputGroup(props: React.PropsWithChildren<InputGroupProps>) {
  const { children, className = '', columnCount } = props;
  const style = columnCount ? { width: `${100 / columnCount}%` } : undefined;

  return (
    <div
      className={`input-group ${className}`}
      data-testid="input-group"
      styleName="container"
    >
      {React.Children.map(
        children,
        child =>
          child && (
            <div className="input-group__child" style={style} styleName="cell">
              {child}
            </div>
          )
      )}
    </div>
  );
}

export default InputGroup;
